module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/icon_Blue_Licensing-5c09c91300c15fef71b8d963af8e5488.png";